<template>
  <v-dialog
    :model-value="openDialog"
    persistent
    :max-width="pxSize"
    :max-height="pxHeight"
  >
    <v-card
      class="pa-7"
      :style="[height ? heightStyle : '', 'border-radius: 12px']"
    >
      <v-card-title class="pa-0">
        <PDialogHeader :title="header" @close-dialog="close" />
      </v-card-title>
      <v-card-text class="px-0 pb-0">
        <v-row :class="`text-${contentAlignment} fill-height`" no-gutters>
          <v-col>
            <slot name="content"></slot>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        v-if="$slots.leftbutton || $slots.rightbutton"
        class="pl-0"
      >
        <slot name="leftbutton"></slot>
        <v-spacer></v-spacer>
        <slot name="rightbutton"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import PDialogHeader from "@/components/custom/PDialogHeader.vue";
import { computed, ref } from "vue";

const emit = defineEmits<{
  (e: "closeDialog"): void;
}>();

const props = withDefaults(
  defineProps<{
    openDialog: boolean;
    header: string;
    size?: "small" | "medium" | "large";
    contentAlignment?: "left" | "center" | "right";
    height?: "small" | "medium" | "large";
  }>(),
  {
    size: "medium",
    contentAlignment: "left",
  }
);

const pxSize = computed(() => {
  switch (props.size) {
    case "small":
      return "750px";
    case "medium":
      return "1000px";
    case "large":
      return "1250px";
  }
});

const pxHeight = computed(() => {
  switch (props.height) {
    case "small":
      return "250px";
    case "medium":
      return "500px";
    case "large":
      return "700px";
  }
});

const heightStyle = ref({
  height: pxHeight,
});

const close = () => {
  emit("closeDialog");
};
</script>
